import {post, get} from '@/utils/http'

/**
 * 创建支付订单
 * @param deviceId
 * @param amount
 * @param buyType
 * @param payType
 * @param period
 * @param bizType
 * @returns {Promise<ResultDTO<ThirdPayOrder>>}
 */
async function doCreateMemberOrder({deviceId, amount, buyType, payType, bizType, period}){
    return post("/pay/createMemberOrder", {deviceId, amount, buyType, period, payType, bizType});
}

/**
 * 获取会员付费选项
 * @param bizType string
 * @returns {Promise<ResultDTO<MemberPayVO>>}
 */
async function getPayOptions(bizType){
    return get("/pay/getPayOptions", {bizType});
}

/**
 *
 * @param tradeOrderNo 订单号
 * @returns {Promise<ResultDTO<ThirdPayOrder>>}
 */
async function queryPayOrder(tradeOrderNo){
    return get("/pay/queryPayOrder", {tradeOrderNo});
}


export default {
    doCreateMemberOrder,getPayOptions,queryPayOrder
}
